<template>
    <div class="centers">
        <div class="clearfix" style="margin-bottom:12px;">
            <p class="floatL">Warehousing</p>
            <p class="floatR"><el-button type="text" icon="el-icon-tickets"><a href="http://www.sendfromchina.com/logistics/shipping" target="_black">Shipping</a></el-button></p>
        </div>
        <template>
            <el-table :data="tableData" border v-loading="loading">
                <el-table-column label="Fee item" prop="name" width="180"></el-table-column>
                <el-table-column label="Charging method" prop="role" width="200"></el-table-column>
                <el-table-column label="Original cost" prop="price" width="180"></el-table-column>
                <el-table-column label="Discount" prop="discount" width="180">
                    <template slot="header">
                        Discount
                    </template>
                </el-table-column>
                <el-table-column label="Discount price" prop="dis_price" width="180"></el-table-column>
                <el-table-column label="Note" prop="note"></el-table-column>
            </el-table>
        </template>
    </div>
</template>
<script>
import { getMyPrice } from '../api/finance'
import { getToken } from '../../utils/auth'
import store from '@/store'

export default {
  data () {
    return {
      customer_id: '',
      tableData: [

      ],
      loading: false
    }
  },
  beforeCreate () {
    if (store.getters.shopTokenuser != undefined) {
      let user = store.getters.shopTokenuser
      this.customer_id = user.customer_id
    }
  },
  created () {
    if (store.getters.shopTokenuser != undefined) {
      let user = store.getters.shopTokenuser
      this.customer_id = user.customer_id
    }
    // 生命周期，请求处理数据
    this.getList()
  },
  methods: {

    getList () {
      const params = {
        customer_id: this.customer_id
      }
      this.loading = true
      getMyPrice(params).then(response => {
        if (response.data.ask === 1 && response.data.data) {
          this.tableData = response.data.data
          this.tableData.forEach((value) => {
            if (value.name === 'CBM') {
              value.note = 'If the average daily consumption within the billing cycle is less than 0.5 cbm, we will bill you 0.5 cbm per day'
            } else if (value.name === 'Item(First)') {
              value.note = 'If the number of items in the billing cycle is less than 10, we will bill you 100 item'
            }
          })
        } else {
          this.tableData = []
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
    .centers{
        text-align: left;
        margin-top: 20px;
        padding: 20px;
        border: 1px solid #DCDFE6;
    }
    .floatL{
        float: left;
    }
    .floatR{
        float: right;
    }
    .clearfix{
        overflow:hidden;
        _zoom:1;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Finance/myPrice.vue